import { ActivatedRouteSnapshot, ResolveFn, Route } from '@angular/router';
import { inject } from '@angular/core';
import {
  BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID,
  BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID,
  DienstleistungSucheParamKeys,
  IDienstleistungSucheParams,
  isApiAbschlussPartner,
  MgsRole,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';
import { DienstleistungListService } from './dienstleistung-list.service';
import { mgsExclusionRoleGuard } from '../../mgs-guards';
import { dienstleistungArtenResolver } from '../dienstleistung-arten.resolver';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { DIENSTLEISTUNGEN_PATH, DIENSTLEISTUNGEN_TITLE } from '../../mgs-path-defs';
import { ProgrammService } from '../../programm/programm.service';
import { AuthStateFacade } from '../../auth/auth-state.facade';

export const dienstleistungenResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const service = inject(DienstleistungListService);
  const authStateFacade = inject(AuthStateFacade);

  const programmeService = inject(ProgrammService);

  const queryParam = (key: DienstleistungSucheParamKeys, asNumber = false) => {
    const value = route.queryParams[key];
    return value ? (asNumber ? +value : value) : undefined;
  };

  if (authStateFacade.isAdmin()) {
    const params: IDienstleistungSucheParams = {
      kundennr: queryParam('kundennr', true),
      kundeId: queryParam('kundeId', true),
      code: queryParam('code'),
      bearbeiterUserId: queryParam('bearbeiterUserId'),
      bearbeitungsStatusId: queryParam('bearbeitungsStatusId', true),
      dienstleistungsArtId: queryParam('dienstleistungsArtId', true),
      vonDatum: queryParam('vonDatum'),
      bisDatum: queryParam('bisDatum'),
      geburtsDatum: queryParam('geburtsDatum'),
      name: queryParam('name'),
      vorName: queryParam('vorName')
    };

    if (
      params.kundennr ||
      params.kundeId ||
      params.code ||
      params.bearbeiterUserId ||
      params.bearbeitungsStatusId ||
      params.dienstleistungsArtId ||
      params.vonDatum ||
      params.bisDatum ||
      params.geburtsDatum ||
      params.name ||
      params.vorName
    ) {
      await service.findDienstleistungen(params);
    }
  }

  if (!service.dienstleistungUpdatedState().loaded()) {
    let params: IDienstleistungSucheParams;
    if (!authStateFacade.isAdmin() && isApiAbschlussPartner(programmeService.partnerProgramme())) {
      params = { bearbeitungsStatusId: BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID, partnerDienstleistungen: true };
    } else {
      params = { bearbeitungsStatusId: BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID };
    }
    await service.findDienstleistungen(params);
  }
};

export const dienstleistungListRolesForExclusion: MgsRole[] = [
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_BUCHUNG
];

export const dienstleistungListRoute: Route = {
  path: DIENSTLEISTUNGEN_PATH,
  title: DIENSTLEISTUNGEN_TITLE,
  resolve: {
    dienstleistungen: dienstleistungenResolver,
    dienstleistungsArten: dienstleistungArtenResolver,
    icons: mgsIconsResolver
  },
  loadComponent: () => import('./dienstleistung-list.component'),
  canActivate: [mgsExclusionRoleGuard(dienstleistungListRolesForExclusion)]
};
